
// Store Supabase configuration values for reuse
// This avoids accessing protected properties directly

// Use the same values from the client.ts file
export const SUPABASE_URL = "https://mnfwgdxgthnojhcufndt.supabase.co";
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1uZndnZHhndGhub2poY3VmbmR0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwMTQyODIsImV4cCI6MjA1ODU5MDI4Mn0.d-DhDqzkMVCISKamcecsmpwuctHFZrDoAzjSA_rGI_I";

// Helper function to get the functions URL
export const getFunctionsUrl = () => {
  return SUPABASE_URL.replace('.supabase.co', '.functions.supabase.co');
};
